import React from 'react';
import {
  FilterBlock,
  FilterBlockHeader,
  FilterBlockTitle,
  HideShowToggle,
  FilterRow,
  FilterLine,
  FilterLineLabel,
  FilterInput,
} from './TicketFiltersSection.styles';

export const TicketFiltersSection = ({
  touchedFields,
  isExpanded,
  onToggle,
  statusFilter,
  sortFilter,
  dateRangeFilter,
  showBusinessFilter,
  businessFilter,
  brandFilter,
}) => {
  return (
    <FilterBlock>
      <FilterBlockHeader>
        <FilterBlockTitle>Ticket filters</FilterBlockTitle>
        <HideShowToggle onClick={onToggle}>
          <span>{isExpanded ? 'Hide' : 'Show'}</span>
          <img
            src={isExpanded ? '/images/new-designs/chevron-up-blue.svg' : '/images/new-designs/chevron-down-blue.svg'}
            alt=""
          />
        </HideShowToggle>
      </FilterBlockHeader>

      {isExpanded && (
        <>
          <FilterRow>
            <FilterLine>
              <FilterLineLabel>Status</FilterLineLabel>
              <FilterInput $isTouched={touchedFields.ticketStatus}>{statusFilter}</FilterInput>
            </FilterLine>

            <FilterLine>
              <FilterLineLabel>Sort by</FilterLineLabel>
              <FilterInput $isTouched={touchedFields.sortOrder}>{sortFilter}</FilterInput>
            </FilterLine>

            <FilterLine>
              <FilterLineLabel>Time range</FilterLineLabel>
              <FilterInput $isTouched={touchedFields.dateRange}>{dateRangeFilter}</FilterInput>
            </FilterLine>
          </FilterRow>

          {showBusinessFilter && (
            <FilterRow>
              <FilterLine>
                <FilterLineLabel>Partner</FilterLineLabel>
                <FilterInput $isTouched={touchedFields.businessIds}>{businessFilter}</FilterInput>
              </FilterLine>

              <FilterLine>
                <FilterLineLabel>Brand</FilterLineLabel>
                <FilterInput $isTouched={touchedFields.selectedBrandOptions}>{brandFilter}</FilterInput>
              </FilterLine>
            </FilterRow>
          )}
        </>
      )}
    </FilterBlock>
  );
};
